<template>
  <button :class="['btn', `btn-${variant}`]"
          :disabled="disabled"
          type="button"
          tabindex="0"
          @click="clicked">
    <slot></slot>
  </button>
</template>

<script>
  export default {
    name: 'ihu-button',
    props: {
      variant: {
        type: String,
        required: false,
        default: 'primary',
      },
      disabled: {
        type: Boolean,
        required: false,
        default: false,
      },
    },
    data() {
      return {};
    },
    methods: {
      clicked(ev) {
        this.$emit('click', ev);
      },
    },
  };
</script>

<style scoped lang="scss">
  .btn {
    font-family: Roboto;
    font-style: normal;
    font-size: 16.8px;
    line-height: 20.16px;

    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 7.5px 16px;
    border-radius: 4px;
    min-height: 40px;
    background-color: transparent;
    border: 1px solid transparent;

    &:not(:disabled):not(.disabled) {
      cursor: pointer;
    }

    &-primary {
      @include themify {
        color: getColor('ihu-button-color', 'ihu') !important;
        background-color: getColor('ihu-button-bg', 'ihu') !important;
      }
      &:hover:not(:disabled):not(.disabled) {
        @include themify {
          background-color: getColor('ihu-button-hover-bg', 'ihu') !important;
        }
      }
      &:focus:not(:disabled):not(.disabled) {
        @include themify {
          background-color: getColor('ihu-button-focus-bg', 'ihu') !important;
        }
      }
    }

    &-secondary {
      border-width: 2px;
      border-style: solid;

      @include themify {
        color: getColor('ihu-button-secondary-color', 'ihu') !important;
        border-color: getColor('ihu-button-secondary-border-color', 'ihu') !important;
        background-color: getColor('ihu-button-secondary-bg', 'ihu') !important;
      }

      &:hover:not(:disabled):not(.disabled) {
        @include themify {
          background-color: getColor('ihu-button-secondary-hover-bg', 'ihu') !important;
        }
      }

      &:focus:not(:disabled):not(.disabled) {
        @include themify {
          background-color: getColor('ihu-button-secondary-focus-bg', 'ihu') !important;
        }
      }
    }

    &-tertiary {
      border-width: 2px;
      border-style: solid;

      @include themify {
        color: getColor('ihu-button-tertiary-color', 'ihu') !important;
        border-color: getColor('ihu-button-tertiary-border-color', 'ihu') !important;
      }

      &:hover:not(:disabled):not(.disabled) {
        @include themify {
          background-color: getColor('ihu-button-tertiary-hover-bg', 'ihu') !important;
          border-color: getColor('ihu-button-tertiary-hover-border-color', 'ihu') !important;
        }
      }

      &:focus:not(:disabled):not(.disabled) {
        @include themify {
          background-color: getColor('ihu-button-tertiary-focus-bg', 'ihu') !important;
        }
      }
    }

    &-bg-transparent {
      background: transparent;
      border: none;
    }

    &-link {
      text-decoration: none;
    }
  }
  .btn:disabled, .btn.disabled {
    opacity: .35;
  }
</style>
